export const contactPersons = [
    {
        id: 1,
        roleKey: "companyOfficial",
        name: "Atahan ÖZDEMİR",
        positionKey: "owner",
        phone: "+90 258 269 13 41",
        email: "atahan@doksan.com"
    },
    {
        id: 2,
        roleKey: "homeTextileSales",
        name: "Alptekin AYYAVUZ",
        positionKey: "marketingDirector",
        phone: "+90 258 269 13 41",
        email: "alptekin@doksan.com"
    },
    {
        id: 3,
        roleKey: "productionOfficial",
        name: "Bayram Ali DAŞÇI",
        positionKey: "generalCoordinator",
        phone: "+90 258 269 13 41",
        email: "bayramali@doksan.com"
    },
    {
        id: 4,
        roleKey: "productDevelopment",
        name: "Özlem KÜÇÜKTERCİ",
        positionKey: "productDevDirector",
        phone: "+90 258 269 13 41",
        email: "ozlem@doksan.com"
    },
    {
        id: 5,
        roleKey: "rnd",
        name: "Barış MANCAR",
        positionKey: "rndDirector",
        phone: "+90 258 269 13 41",
        email: "b.mancar@doksan.com"
    },
    {
        id: 6,
        roleKey: "auditOfficial",
        name: "Gökhan PALA",
        positionKey: "socialCompliance",
        phone: "+90 258 269 13 41",
        email: "sosyal@doksan.com"
    }
];
